import * as React from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import TreeView from '@mui/lab/TreeView';
import TreeItem, { TreeItemProps, treeItemClasses } from '@mui/lab/TreeItem';
import Typography from '@mui/material/Typography';
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import CheckBoxOutlineBlankOutlinedIcon from '@mui/icons-material/CheckBoxOutlineBlankOutlined';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import { SvgIconProps } from '@mui/material/SvgIcon';
import { Chip } from '@mui/material';
declare module 'react' {
  interface CSSProperties {
    '--tree-view-color'?: string;
    '--tree-view-bg-color'?: string;
  }
}

type StyledTreeItemProps = TreeItemProps & {
  bgColor?: string;
  color?: string;
  labelIcon: React.ElementType<SvgIconProps>;
  labelInfo?: string;
  labelText: string;
  backgroundColorInfo?: string;
};

const StyledTreeItemRoot = styled(TreeItem)(({ theme }) => ({
  color: theme.palette.text.secondary,
  [`& .${treeItemClasses.content}`]: {
    color: theme.palette.text.secondary,
    borderTopRightRadius: theme.spacing(2),
    borderBottomRightRadius: theme.spacing(2),
    paddingRight: theme.spacing(1),
    fontWeight: theme.typography.fontWeightMedium,
    '&.Mui-expanded': {
      fontWeight: theme.typography.fontWeightRegular,
    },
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
    '&.Mui-focused, &.Mui-selected, &.Mui-selected.Mui-focused': {
      backgroundColor: `var(--tree-view-bg-color, ${theme.palette.action.selected})`,
      color: 'var(--tree-view-color)',
    },
    [`& .${treeItemClasses.label}`]: {
      fontWeight: 'inherit',
      color: 'inherit',
    },
  },
  [`& .${treeItemClasses.group}`]: {
    marginLeft: 0,
    [`& .${treeItemClasses.content}`]: {
      paddingLeft: theme.spacing(3),
    },
  },
}));

function StyledTreeItem(props: StyledTreeItemProps) {
  const {
    bgColor,
    color,
    labelIcon: LabelIcon,
    labelInfo,
    backgroundColorInfo,
    labelText,
    ...other
  } = props;

  return (
    <StyledTreeItemRoot
      label={
        <Box sx={{ display: 'flex', alignItems: 'center', p: 0.5, pr: 0 }}>
          <Box component={LabelIcon} color="inherit" sx={{ mr: 1 }} />
          <Typography
            variant="body2"
            sx={{ fontWeight: 'inherit', flexGrow: 1 }}
          >
            {labelText}
          </Typography>
          {labelInfo && (
            <Chip label={labelInfo}
              size="extraSmall"
              sx={{
                fontSize: '0.5rem',
                height: 16,
                color: 'white',
                backgroundColor: backgroundColorInfo ? backgroundColorInfo : color,
              }}
            />
          )}
          
          {/*<Typography variant="caption" color="inherit">
            {labelInfo}
          </Typography>*/}
        </Box>
      }
      style={{
        '--tree-view-color': color,
        '--tree-view-bg-color': bgColor,
      }}
      {...other}
    />
  );
}

const MenuTreeView = React.forwardRef(
  ({ data, onClickItem, isFormFinalize, isTestFinalize, isSublessonFinalize, onChangeMenu, isDisabledNext }, ref) => {
    
    const [dataMenu, setDataMenu] = React.useState([]);
    //const [selectedNode, setSelectedNode] = React.useState(null);
    const selectedNode = React.useRef(null);
    const [expanded, setExpanded] = React.useState<string[]>([]);
    const setSelectedNode = (nodeId) => {
      selectedNode.current = nodeId
    }

    const setSelectedNodeActive = async (nodeId, finalize) => {
      const nodeIdParts = nodeId.split('-');
      //setSelectedNode(nodeId);
      
      let dataCopyMenu = JSON.parse(JSON.stringify(dataMenu));
      if (selectedNode.current) {
        const selectedNodeParts = selectedNode.current.split('-');
       
        if (selectedNodeParts[0] == 'SUBLESSON') {
          if (
            !dataCopyMenu[parseInt(selectedNodeParts[1])].lessons[
              parseInt(selectedNodeParts[2])
            ].sublessons[parseInt(selectedNodeParts[3])].cod_formulario &&
            !dataCopyMenu[parseInt(selectedNodeParts[1])].lessons[
              parseInt(selectedNodeParts[2])
            ].sublessons[parseInt(selectedNodeParts[3])].test_id &&
            isSublessonFinalize
          ) {
            dataCopyMenu[parseInt(selectedNodeParts[1])].lessons[
              parseInt(selectedNodeParts[2])
            ].sublessons[parseInt(selectedNodeParts[3])].viewed = 1;
            if (isDisabledNext) {
              dataCopyMenu[parseInt(selectedNodeParts[1])].lessons[
                parseInt(selectedNodeParts[2])
              ].sublessons[parseInt(selectedNodeParts[3])].disabled = false;
            }
          }

          if (
            dataCopyMenu[parseInt(selectedNodeParts[1])].lessons[
              parseInt(selectedNodeParts[2])
            ].sublessons[parseInt(selectedNodeParts[3])].test_id &&
            finalize
          ) {
            dataCopyMenu[parseInt(selectedNodeParts[1])].lessons[
              parseInt(selectedNodeParts[2])
            ].sublessons[parseInt(selectedNodeParts[3])].viewed = 1;
            if (isDisabledNext) {
              dataCopyMenu[parseInt(selectedNodeParts[1])].lessons[
                parseInt(selectedNodeParts[2])
              ].sublessons[parseInt(selectedNodeParts[3])].disabled = false;
            }
          }

          if (
            dataCopyMenu[parseInt(selectedNodeParts[1])].lessons[
              parseInt(selectedNodeParts[2])
            ].sublessons[parseInt(selectedNodeParts[3])].cod_formulario &&
            finalize
          ) {
            dataCopyMenu[parseInt(selectedNodeParts[1])].lessons[
              parseInt(selectedNodeParts[2])
            ].sublessons[parseInt(selectedNodeParts[3])].viewed = 1;
            if (isDisabledNext) {
              dataCopyMenu[parseInt(selectedNodeParts[1])].lessons[
                parseInt(selectedNodeParts[2])
              ].sublessons[parseInt(selectedNodeParts[3])].disabled = false;
            }
          }
          for (let i = 0; i < dataCopyMenu.length; i++) {
            if (dataCopyMenu[i].lessons && dataCopyMenu[i].lessons.length > 0) {
              for (let j = 0; j < dataCopyMenu[i].lessons.length; j++) {
                dataCopyMenu[i].lessons[j]["viewed"] = checkLesson(dataCopyMenu[i].lessons[j]) ? 1 : 0;
              }
              dataCopyMenu[i]["viewed"] = checkUnit(dataCopyMenu[i]) ? 1 : 0
            }
          }

        }

        if (selectedNodeParts[0] == 'LESSON' && dataCopyMenu[parseInt(selectedNodeParts[1])].lessons[
          parseInt(selectedNodeParts[2])
        ].operativa == 1) {
          if (
            !dataCopyMenu[parseInt(selectedNodeParts[1])].lessons[
              parseInt(selectedNodeParts[2])
            ].cod_formulario &&
            !dataCopyMenu[parseInt(selectedNodeParts[1])].lessons[
              parseInt(selectedNodeParts[2])
            ].test_id &&
            isSublessonFinalize
          ) {
            dataCopyMenu[parseInt(selectedNodeParts[1])].lessons[
              parseInt(selectedNodeParts[2])
            ].viewed = 1;
            if (isDisabledNext) {
              dataCopyMenu[parseInt(selectedNodeParts[1])].lessons[
                parseInt(selectedNodeParts[2])
              ].disabled = false;
            }
          }

          if (
            dataCopyMenu[parseInt(selectedNodeParts[1])].lessons[
              parseInt(selectedNodeParts[2])
            ].test_id &&
            finalize
          ) {
            dataCopyMenu[parseInt(selectedNodeParts[1])].lessons[
              parseInt(selectedNodeParts[2])
            ].viewed = 1;
            if (isDisabledNext) {
              dataCopyMenu[parseInt(selectedNodeParts[1])].lessons[
                parseInt(selectedNodeParts[2])
              ].disabled = false;
            }
          }

          if (
            dataCopyMenu[parseInt(selectedNodeParts[1])].lessons[
              parseInt(selectedNodeParts[2])
            ].cod_formulario &&
            finalize
          ) {
            dataCopyMenu[parseInt(selectedNodeParts[1])].lessons[
              parseInt(selectedNodeParts[2])
            ].viewed = 1;
            if (isDisabledNext) {
              dataCopyMenu[parseInt(selectedNodeParts[1])].lessons[
                parseInt(selectedNodeParts[2])
              ].disabled = false
            }
          }
          for (let i = 0; i < dataCopyMenu.length; i++) {
            if (dataCopyMenu[i].lessons && dataCopyMenu[i].lessons.length > 0) {
              for (let j = 0; j < dataCopyMenu[i].lessons.length; j++) {
                dataCopyMenu[i].lessons[j]["viewed"] = checkLesson(dataCopyMenu[i].lessons[j]) ? 1 : 0;
              }
              dataCopyMenu[i]["viewed"] = checkUnit(dataCopyMenu[i]) ? 1 : 0
             
            }
          }
        }
      }
      if (isDisabledNext) {
        const disabledNodesFinal = disabledNodes(dataCopyMenu)
        onChangeMenu(disabledNodesFinal);
        setDataMenu(disabledNodesFinal);
      } else {
        onChangeMenu(dataCopyMenu);
        setDataMenu(dataCopyMenu);
      }

      let data = {};
      let nextNodeId = null;
      switch (nodeIdParts[0]) {
        case 'UNIT':
          data = JSON.parse(JSON.stringify(dataMenu[parseInt(nodeIdParts[1])]));
          delete data.lessons;

          if (dataMenu[parseInt(nodeIdParts[1])].lessons && dataMenu[parseInt(nodeIdParts[1])].lessons.length > 0) {
            nextNodeId = `LESSON-${parseInt(nodeIdParts[1])}-${0}`;
          } else {
            if (dataMenu[parseInt(nodeIdParts[1]) + 1]) {
              nextNodeId = `UNIT-${(parseInt(nodeIdParts[1]) + 1)}-${dataMenu[parseInt(nodeIdParts[1]) + 1].cod_unidad
                }`;
            }
          }
          if (isDisabledNext && data.disabled) {
            return false
          }
          setExpanded([nodeId]);
          break;

        case 'LESSON':
          data = JSON.parse(
            JSON.stringify(
              dataMenu[parseInt(nodeIdParts[1])].lessons[
              parseInt(nodeIdParts[2])
              ]
            )
          );

          if (dataMenu[parseInt(nodeIdParts[1])].lessons[parseInt(nodeIdParts[2])].sublessons && dataMenu[parseInt(nodeIdParts[1])].lessons[parseInt(nodeIdParts[2])].sublessons.length > 0) {
            nextNodeId = `SUBLESSON-${nodeIdParts[1]}-${parseInt(nodeIdParts[2])}-${0}`
          }

          if (!dataMenu[parseInt(nodeIdParts[1])].lessons[parseInt(nodeIdParts[2])].sublessons || dataMenu[parseInt(nodeIdParts[1])].lessons[parseInt(nodeIdParts[2])].sublessons.length == 0) {

            if (dataMenu[parseInt(nodeIdParts[1])].lessons[parseInt(nodeIdParts[2]) + 1]) {
              nextNodeId = `LESSON-${parseInt(nodeIdParts[1])}-${(parseInt(nodeIdParts[2]) + 1)}`;
            } else {
              if (dataMenu[parseInt(nodeIdParts[1]) + 1]) {
                nextNodeId = `UNIT-${parseInt(nodeIdParts[1]) + 1}-${dataMenu[parseInt(nodeIdParts[1]) + 1].cod_unidad
                  }`;
              }
            }
          }
          if (isDisabledNext && data.disabled) {
            return false
          }
          setExpanded([expanded[0], nodeId]);
          break;

        case 'SUBLESSON':
          data = JSON.parse(
            JSON.stringify(
              dataMenu[parseInt(nodeIdParts[1])]['lessons'][
              parseInt(nodeIdParts[2])
              ]['sublessons'][parseInt(nodeIdParts[3])]
            )
          );

          if (
            dataMenu[parseInt(nodeIdParts[1])].lessons[parseInt(nodeIdParts[2])]
              .sublessons.length -
            1 ==
            parseInt(nodeIdParts[3])
          ) {
            if (
              dataMenu[parseInt(nodeIdParts[1])].lessons[
              parseInt(nodeIdParts[2]) + 1
              ]
            ) {
              nextNodeId = `LESSON-${parseInt(nodeIdParts[1])}-${parseInt(nodeIdParts[2]) + 1
                }`;
            } else {
              if (dataMenu[parseInt(nodeIdParts[1]) + 1]) {
                nextNodeId = `UNIT-${parseInt(nodeIdParts[1]) + 1}-${dataMenu[parseInt(nodeIdParts[1]) + 1].cod_unidad
                  }`;
              }
            }
          } else {
            nextNodeId = `SUBLESSON-${parseInt(nodeIdParts[1])}-${parseInt(
              nodeIdParts[2]
            )}-${parseInt(nodeIdParts[3]) + 1}`;
          }

          break;
      }

      setSelectedNode(nodeId);
      onClickItem(nodeIdParts[0], data, nextNodeId);
    };

    const updatedNodes = () => {
      let dataCopyMenu = JSON.parse(JSON.stringify(dataMenu));
      if (selectedNode.current) {
      
          const selectedNodeParts = selectedNode.current.split('-');
          if (selectedNodeParts[0] == 'SUBLESSON') {
            if (
              !dataCopyMenu[parseInt(selectedNodeParts[1])].lessons[
                parseInt(selectedNodeParts[2])
              ].sublessons[parseInt(selectedNodeParts[3])].cod_formulario &&
              !dataCopyMenu[parseInt(selectedNodeParts[1])].lessons[
                parseInt(selectedNodeParts[2])
              ].sublessons[parseInt(selectedNodeParts[3])].test_id &&
              isSublessonFinalize
            ) {
              dataCopyMenu[parseInt(selectedNodeParts[1])].lessons[
                parseInt(selectedNodeParts[2])
              ].sublessons[parseInt(selectedNodeParts[3])].viewed = 1;
              if (isDisabledNext) {
                dataCopyMenu[parseInt(selectedNodeParts[1])].lessons[
                  parseInt(selectedNodeParts[2])
                ].sublessons[parseInt(selectedNodeParts[3])].disabled = false;
              }
            }

            if (
              dataCopyMenu[parseInt(selectedNodeParts[1])].lessons[
                parseInt(selectedNodeParts[2])
              ].sublessons[parseInt(selectedNodeParts[3])].test_id &&
              isTestFinalize
            ) {
              dataCopyMenu[parseInt(selectedNodeParts[1])].lessons[
                parseInt(selectedNodeParts[2])
              ].sublessons[parseInt(selectedNodeParts[3])].viewed = 1;
              if (isDisabledNext) {
                dataCopyMenu[parseInt(selectedNodeParts[1])].lessons[
                  parseInt(selectedNodeParts[2])
                ].sublessons[parseInt(selectedNodeParts[3])].disabled = false;
              }
            }

            if (
              dataCopyMenu[parseInt(selectedNodeParts[1])].lessons[
                parseInt(selectedNodeParts[2])
              ].sublessons[parseInt(selectedNodeParts[3])].cod_formulario &&
              isFormFinalize
            ) {
              dataCopyMenu[parseInt(selectedNodeParts[1])].lessons[
                parseInt(selectedNodeParts[2])
              ].sublessons[parseInt(selectedNodeParts[3])].viewed = 1;
              if (isDisabledNext) {
                dataCopyMenu[parseInt(selectedNodeParts[1])].lessons[
                  parseInt(selectedNodeParts[2])
                ].sublessons[parseInt(selectedNodeParts[3])].disabled = false;
              }
            }

            for (let i = 0; i < dataCopyMenu.length; i++) {
              if (dataCopyMenu[i].lessons && dataCopyMenu[i].lessons.length > 0) {
                for (let j = 0; j < dataCopyMenu[i].lessons.length; j++) {
                  dataCopyMenu[i].lessons[j]["viewed"] = checkLesson(dataCopyMenu[i].lessons[j]) ? 1 : 0;
                }
                dataCopyMenu[i]["viewed"] = checkUnit(dataCopyMenu[i]) ? 1 : 0
              }
            }

          }

          if (selectedNodeParts[0] == 'LESSON' && dataCopyMenu[parseInt(selectedNodeParts[1])].lessons[
            parseInt(selectedNodeParts[2])
          ].operativa == 1) {
            if (
              !dataCopyMenu[parseInt(selectedNodeParts[1])].lessons[
                parseInt(selectedNodeParts[2])
              ].cod_formulario &&
              !dataCopyMenu[parseInt(selectedNodeParts[1])].lessons[
                parseInt(selectedNodeParts[2])
              ].test_id &&
              isSublessonFinalize
            ) {
              dataCopyMenu[parseInt(selectedNodeParts[1])].lessons[
                parseInt(selectedNodeParts[2])
              ].viewed = 1;
              if (isDisabledNext) {
                dataCopyMenu[parseInt(selectedNodeParts[1])].lessons[
                  parseInt(selectedNodeParts[2])
                ].disabled = false;
              }
            }

            if (
              dataCopyMenu[parseInt(selectedNodeParts[1])].lessons[
                parseInt(selectedNodeParts[2])
              ].test_id &&
              isTestFinalize
            ) {
              dataCopyMenu[parseInt(selectedNodeParts[1])].lessons[
                parseInt(selectedNodeParts[2])
              ].viewed = 1;
              if (isDisabledNext) {
                dataCopyMenu[parseInt(selectedNodeParts[1])].lessons[
                  parseInt(selectedNodeParts[2])
                ].disabled = false;
              }
            }

            if (
              dataCopyMenu[parseInt(selectedNodeParts[1])].lessons[
                parseInt(selectedNodeParts[2])
              ].cod_formulario &&
              isFormFinalize
            ) {
              dataCopyMenu[parseInt(selectedNodeParts[1])].lessons[
                parseInt(selectedNodeParts[2])
              ].viewed = 1;
              if (isDisabledNext) {
                dataCopyMenu[parseInt(selectedNodeParts[1])].lessons[
                  parseInt(selectedNodeParts[2])
                ].disabled = false
              }
            }

            for (let i = 0; i < dataCopyMenu.length; i++) {
              if (dataCopyMenu[i].lessons && dataCopyMenu[i].lessons.length > 0) {
                for (let j = 0; j < dataCopyMenu[i].lessons.length; j++) {
                  dataCopyMenu[i].lessons[j]["viewed"] = checkLesson(dataCopyMenu[i].lessons[j]) ? 1 : 0;
                }
                dataCopyMenu[i]["viewed"] = checkUnit(dataCopyMenu[i])
              }
            }

          }
        
      }
     
      if (isDisabledNext) {
        const disabledNodesFinal = disabledNodes(dataCopyMenu)
        onChangeMenu(disabledNodesFinal);
        setDataMenu(disabledNodesFinal);
      } else {
        onChangeMenu(dataCopyMenu);
        setDataMenu(dataCopyMenu);
      }
    }

    const handleSelect = (event, nodeIds) => {
      const nodeIdParts = nodeIds.split('-');
      if (nodeIdParts[0] == 'LESSON') {
        if (nodeIds != expanded[1]) {
          setExpanded([expanded[0], nodeIds]);
        } else {
          setExpanded([expanded[0]]);
        }
      }
      if (nodeIdParts[0] == 'UNIT') {
        if (nodeIds != expanded[0]) {
          setExpanded([nodeIds]);
        } else {
          setExpanded([]);
        }
      }
      updatedNodes();
    };

    const checkLesson = (lesson) => {
      if (lesson.operativa == 1) return lesson.viewed == 1
      return (
        lesson.sublessons &&
        Array.isArray(lesson.sublessons) &&
        lesson.sublessons.filter((ele) => ele.viewed == 0).length == 0
      );
    };

    const checkLessonDisabled = (lesson) => {
      return (
        lesson.sublessons &&
        Array.isArray(lesson.sublessons) &&
        lesson.sublessons.filter((ele) => ele.viewed == 0).length == 0
      );
    };

    const checkUnit = (unit) => {
      return (
        unit.lessons &&
        Array.isArray(unit.lessons) &&
        unit.lessons.filter((ele) => ele.viewed == 0).length == 0
      );
    };

    const normalizeLessons = (nodeWork) => {
      for (let j = 0; j < nodeWork.lessons.length; j++) {

        let isDisabled = true
        if (j == 0) isDisabled = false

        
        if (j > 0) {

          if (checkLessonDisabled(nodeWork.lessons[j - 1]) || nodeWork.lessons[j - 1].viewed) isDisabled = false
          if (nodeWork.lessons[j - 1].disabled) isDisabled = true
        }

        nodeWork.lessons[j]["disabled"] = isDisabled
        if (nodeWork.lessons[j].sublessons) {
          nodeWork.lessons[j].sublessons = nodeWork.lessons[j].sublessons.map(function (ele) {
            ele.disabled = isDisabled
            return ele
          })
        }

      }
      return nodeWork
    }

    const disabledNodes = (dataMenuCopy) => {

      let currentDataMenu = JSON.parse(JSON.stringify(dataMenuCopy))
      const lastNodeEnabled: number[] = []
      for (let i = 0; i < currentDataMenu.length; i++) {
        let isDisabled = true;
        if (i == 0) isDisabled = false
        if (checkUnit(currentDataMenu[i])) isDisabled = false

        if (i > 0) {
          if (currentDataMenu[i - 1].viewed == 0 && currentDataMenu[i - 1].lessons.length > 0) isDisabled = true
          if (currentDataMenu[i - 1].viewed == 1 && currentDataMenu[i - 1].lessons.length > 0) isDisabled = false
          if (currentDataMenu[i - 1].viewed == 0 && currentDataMenu[i - 1].lessons.length == 0) isDisabled = false
        }

        currentDataMenu[i]["disabled"] = isDisabled;

        if (isDisabled == false) {
          lastNodeEnabled.push(i)
        }

      }
      
      for (let k = 0; k < lastNodeEnabled.length; k++) {
        if (currentDataMenu[k].lessons) {
          const firstDisabled = currentDataMenu[k].lessons.find(element => element.disabled == true)
          if (firstDisabled) {
            currentDataMenu[k] = normalizeLessons(currentDataMenu[k])
          }
        } 
      }


      let nodeWork = currentDataMenu[lastNodeEnabled[lastNodeEnabled.length - 1]];
      if (nodeWork && nodeWork.lessons && nodeWork.lessons.length > 0) currentDataMenu[lastNodeEnabled[lastNodeEnabled.length - 1]] = normalizeLessons(nodeWork)
      return currentDataMenu
    }

    React.useImperativeHandle(ref, () => ({
      setSelectedNode: setSelectedNodeActive
    }));

    React.useEffect(() => {
        if (isDisabledNext) {
          setDataMenu(disabledNodes(data));
        } else {
          setDataMenu(data);
        }
    }, [data]);

    React.useEffect(()=> {
      if (isDisabledNext && isSublessonFinalize) {
        updatedNodes()
      }
    }, [isSublessonFinalize])

    return (
      <TreeView
        id={'tree-view-menu'}
        defaultCollapseIcon={<ArrowDropDownIcon />}
        defaultExpandIcon={<ArrowRightIcon />}
        defaultEndIcon={<div style={{ width: 24 }} />}
        sx={{ height: 264, flexGrow: 1, maxWidth: 500, overflowY: 'auto' }}
        onNodeSelect={handleSelect}
        selected={selectedNode.current}
        expanded={expanded}
      >
        {dataMenu &&
          dataMenu.length > 0 &&
          dataMenu.map((unit, index) => (
            <StyledTreeItem
              disabled={unit?.disabled}
              nodeId={`UNIT-${index}-${unit.cod_unidad}`}
              id={`UNIT-${index}-${unit.cod_unidad}`}
              key={`UNIT-${index}-${unit?.disabled}-${unit.viewed}`}
              labelText={unit.nombre}
              labelIcon={
                unit.lessons.length == 0
                  ? null
                  : checkUnit(unit) || unit.viewed == 1
                    ? CheckBoxOutlinedIcon
                    : CheckBoxOutlineBlankOutlinedIcon
              }
              onClick={() => {
                if (isDisabledNext && unit?.disabled) return false
                updatedNodes();
                setSelectedNode(`UNIT-${index}-${unit.cod_unidad}`);
                let nextNodeId = null;
                if (dataMenu[index].lessons && dataMenu[index].lessons.length > 0) {
                  nextNodeId = `LESSON-${index}-${0}`;
                } else {
                  if (dataMenu[index + 1]) {
                    nextNodeId = `UNIT-${index + 1}-${dataMenu[index + 1].cod_unidad
                      }`;
                  }
                }

                onClickItem('UNIT', unit, nextNodeId);
              }}
            >
              {unit.lessons &&
                unit.lessons.map((lesson, index2) => (
                  <StyledTreeItem
                    disabled={isDisabledNext && lesson?.disabled}
                    nodeId={`LESSON-${index}-${index2}`}
                    key={`LESSON-${index}-${index2}-${lesson?.disabled}-${lesson.viewed}`}
                    labelText={lesson.nombre}
                    labelIcon={
                      checkLesson(lesson) || lesson.viewed == 1
                        ? CheckBoxOutlinedIcon
                        : CheckBoxOutlineBlankOutlinedIcon
                    }
                    color="#1a73e8"
                    bgColor="#e8f0fe"
                    backgroundColorInfo={lesson?.color_fondo_chip}
                    labelInfo={lesson?.texto_chip}
                    onClick={() => {
                      if (isDisabledNext && lesson?.disabled) return false
                      updatedNodes();
                      setSelectedNode(`LESSON-${index}-${index2}`);
                      let nextNodeId = null;

                      if (lesson.sublessons && lesson.sublessons.length > 0) {
                        nextNodeId = `SUBLESSON-${index}-${index2}-${0}`
                      } else {
                        if (!lesson.sublessons || lesson.sublessons.length == 0) {

                          if (dataMenu[index].lessons[index2 + 1]) {
                            nextNodeId = `LESSON-${index}-${index2 + 1}`;
                          } else {
                            if (dataMenu[index + 1]) {
                              nextNodeId = `UNIT-${index + 1}-${dataMenu[index + 1].cod_unidad
                                }`;
                            }
                          }
                        }
                      }
                      onClickItem('LESSON', lesson, nextNodeId);
                    }}
                  >
                    {lesson.sublessons &&
                      lesson.sublessons.map((sublesson, index3) => (
                        <StyledTreeItem
                          nodeId={`SUBLESSON-${index}-${index2}-${index3}`}
                          key={`SUBLESSON-${index}-${index2}-${index3}-${sublesson?.disabled}-${lesson.viewed}`}
                          labelText={sublesson.nombre}
                          labelIcon={
                            sublesson.viewed > 0
                              ? CheckBoxOutlinedIcon
                              : CheckBoxOutlineBlankOutlinedIcon
                          }
                          color="#e3742f"
                          bgColor="#fcefe3"
                          backgroundColorInfo={sublesson?.color_fondo_chip}
                          labelInfo={sublesson?.texto_chip}
                          sx={{ marginLeft: 2 }}
                          onClick={() => {
                            if (isDisabledNext && sublesson?.disabled) return false
                            updatedNodes();
                            setSelectedNode(
                              `SUBLESSON-${index}-${index2}-${index3}`
                            );
                            let nextNodeId = null;
                            if (
                              dataMenu[index].lessons[index2].sublessons
                                .length -
                              1 ==
                              index3
                            ) {
                              if (dataMenu[index].lessons[index2 + 1]) {
                                nextNodeId = `LESSON-${index}-${index2 + 1}`;
                              } else {
                                if (dataMenu[index + 1]) {
                                  nextNodeId = `UNIT-${index + 1}-${dataMenu[index + 1].cod_unidad
                                    }`;
                                }
                              }
                            } else {
                              nextNodeId = `SUBLESSON-${index}-${index2}-${index3 + 1
                                }`;
                            }
                            onClickItem('SUBLESSON', sublesson, nextNodeId);
                          }}
                        />
                      ))}
                  </StyledTreeItem>
                ))}
            </StyledTreeItem>
          ))}
      </TreeView>
    );
  }
);

export default React.memo(MenuTreeView);
